// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3ITQb","col":"CardReaderDesc_col__2vjND","label":"CardReaderDesc_label__1Gsrc"};